module.exports = __webpack_public_path__ + "static/media/на.924e3f7a.mp3";